import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { Markup } from 'interweave';
import clsx from 'clsx';
export interface IMenu {
  id: string;
  icon?: JSX.Element;
  name: string;
  onClick?: () => void;
  devider?: boolean;
  current?: boolean;
  subMenus?: IMenu[];
  width?: number;
  pointer?: string;
  selected?: any;
  setExpanded: any;
  customClass?: string;
}

export const MenuItem = ({ icon, name, devider, subMenus, width, onClick, setExpanded, customClass }: IMenu) => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    onClick && onClick();
    setExpanded(false);
  };

  return (
    <>
      <div
        className={`group relative flex items-center px-4 leading-7 text-[15px] cursor-pointer hover:bg-blue-menu-active ${customClass}`}
        role="menuitem"
        tabIndex={-1}
        id="menu-item-0"
        onClick={handleClick}
      >
        {icon}
        <span
          className={`font-lato text-black font-normal group-hover:text-white leading-4 py-2 break-words ${customClass}`}
        >
          <Markup content={name} />
        </span>
        {subMenus?.length && (
          <>
            <FontAwesomeIcon
              icon={faAngleRight}
              className="w-[14px] h-[14px] text-black group-hover:text-white ml-auto shrink-0"
            />
            <div className="absolute left-full hidden group-hover:block">
              <div
                className="origin-top-left py-4 rounded-md shadow-pop bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="menu-button"
                tabIndex={-1}
                style={{ width: width ? width : 200 }}
              >
                {subMenus.map((el: IMenu) => (
                  <SubMenuItem key={el.id} {...el} />
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      {devider && <div className="my-2 border-b border-gray-popup" />}
    </>
  );
};

export const SubMenuItem = ({ icon, name, devider, pointer, customClass, onClick }: IMenu) => {
  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <>
      <div
        className={clsx(
          'flex items-center px-4 leading-7 text-black text-[15px]',
          {
            'cursor-pointer hover:bg-blue-menu-active hover:text-white': !pointer,
            'cursor-default': pointer === 'disabled'
          },
          `${customClass}`
        )}
        role="menuitem"
        tabIndex={-1}
        id="menu-item-0"
        onClick={handleClick}
      >
        {icon}
        <span className={`font-lato font-normal ${customClass}`}>
          <Markup content={name} />
        </span>
      </div>
      {devider && <div className="my-2 border-b border-gray-popup" />}
    </>
  );
};
